module.exports = __webpack_public_path__ + "3961414e7d4476627b03e11d8ff5ba78.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-7.png
// module id = 2207
// module chunks = 0